import { render } from "./App.vue?vue&type=template&id=1aae5842"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1aae5842&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@5.101.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__